import type { FC } from 'react';

interface RoadmapProgressBarProps {
  completed: number;
  total: number;
}

const RoadmapProgressBar: FC<RoadmapProgressBarProps> = ({ completed, total }) => {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  const barColor =
    pct === 100
      ? 'bg-emerald-500'
      : pct >= 60
        ? 'bg-blue-500'
        : pct >= 30
          ? 'bg-amber-500'
          : 'bg-slate-400';

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1 h-2 rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs font-medium text-slate-600 dark:text-slate-300 tabular-nums whitespace-nowrap">
        {completed}/{total} ({pct}%)
      </span>
    </div>
  );
};

export default RoadmapProgressBar;
